import React, { useEffect, useState } from 'react';

interface ErrorNotificationProps {
    prizeName: string;
    duration?: number; // how long it shows in ms (default 3000)
    category: string;
}

const prizeStyles: Record<string, { color: string; bg: string }> = {
    'Early 5': { color: '#00C000', bg: '#204c0f' },
    'Corners': { color: '#6347BF', bg: '#26126A' },
    '1st Line': { color: '#00BEED', bg: '#00576C' },
    '2nd Line': { color: '#00C8B7', bg: '#00544D' },
    '3rd Line': { color: '#FF5353', bg: '#9F1414' },
    'Full House': { color: '#FF7715', bg: '#963C00' },
    'Last Number': { color: '#E63A8A', bg: '#76001C' },
    'Fast 10': { color: '#327AE6', bg: '#26126A' },
    'Double Line': { color: '#03B97C', bg: '#005035' },
};

const ErrorNotification: React.FC<ErrorNotificationProps> = ({
                                                                 prizeName,
                                                                 category,
                                                                 duration = 3000
                                                             }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
        const timer = setTimeout(() => setVisible(false), duration);
        return () => clearTimeout(timer);
    }, [prizeName, duration]);

    return (
        <div
            style={{
                position: 'fixed',
                top: visible ? '50px' : '-100px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999,
                backgroundColor: prizeStyles[category].color,
                borderRadius: '10px',
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0px 6px 0px ${prizeStyles[category].bg}`,
                color: 'white',
                fontWeight: 'bold',
                fontSize: '14px',
                minWidth: '250px',
                maxWidth: '90vw',
                opacity: visible ? 1 : 0,
                transition: 'top 0.4s ease, opacity 0.4s ease',
                whiteSpace: 'nowrap',
            }}
        >
            <img
                src="./coin.svg"
                alt="Coin"
                draggable={false}
                style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '10px',
                    flexShrink: 0,
                    display: 'block',
                }}
            />
            <span
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    display: 'block',
                    textAlign: 'center',
                }}
            >
                {prizeName}
            </span>
        </div>
    );
};

export default ErrorNotification;
